<template>
  <el-select v-model="value" placeholder="请选择" @change="changeValue($event)">
    <el-option value="" label="请选择" />
    <el-option
      v-for="item in statusData"
      :key="item.code"
      :label="item.name"
      :value="item.code"
    />
  </el-select>
</template>
<script>
export default {
  data() {
    return {
      value: '',
      statusData: [],
      dictType: {
        types: 'palletStatus'
      }
    }
  },
  methods: {
    changeValue(e) {
      this.$emit('queryStatus', this.value)
    },
    setSelectValue(value) {
      this.value = value
    },
    initStatusDict(statusData) {
      this.statusData = statusData
    }
  }
}
</script>
